export default __webpack_public_path__ + "static/media/tree.14df8677.png";